import React, { useState } from 'react';
import { GtmProduct } from '../../../types/go-to-market';
import { CARD_COLORS, CARD_COLORS_HIGHLIGHT, CARD_STYLES } from './ArchitectureDetailStyles';
import { HbrIcon } from '@harbor/elements-react-standalone';
import { caretRight } from '@harbor/elements/icons';
import { Link } from 'react-router-dom';


const ArchitectureProductCard: React.FC<{
  product: GtmProduct,
  hoveredComponent: boolean,
  pinnedComponent: boolean,
}> = ({
  product,
  hoveredComponent,
  pinnedComponent
}) => {
  const [hovered, setHovered] = useState<boolean>(false);

  const pinnedHighlightIdx = product.colorIdx % CARD_COLORS.length;

  const cardStyle = hoveredComponent && pinnedComponent 
    ? CARD_COLORS_HIGHLIGHT[pinnedHighlightIdx]
    : hoveredComponent
      ? 'outline-cisco-blue-60 bg-cisco-blue-10'
      : pinnedComponent
        ? CARD_COLORS[pinnedHighlightIdx]
        : 'outline-gray-20 bg-gray-10'
  const moreTextStyle = hovered
    ? 'text-orange-50'
    : 'text-gray-50';

  return (
    <Link
      to={`/solutions/product/${product.id}`}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      key={product.id}
      className={`${CARD_STYLES} ${cardStyle}`}
      style={{ textDecoration: 'none', color: 'inherit' }}
    >
      <div className={"absolute bottom-2 right-2 flex items-center text-center gap-[2px]"}>
        <div className={`text-xs font-semibold italic ${moreTextStyle} transition-colors duration-300`}>
          Learn more
        </div>
        <HbrIcon
          asset={caretRight}
          className={`${moreTextStyle} transition-colors duration-300`}
        />
      </div>

      <div className="font-semibold">{product.name}</div>
      <div className="flex gap-1 my-1 flex-wrap justify-center w-full">
        {product.architecture?.length !== 0
          ? (
              product.architecture?.map((architecture) => (
                <div
                  key={architecture.id}
                  className="bg-gray-20 py-px whitespace-nowrap leading-5 px-3 rounded-xl border border-gray-30 text-xs"
                >
                  {architecture.name}
                </div>
                
              ))
            )
          : (
              <div className="bg-gray-20 py-1 px-3 rounded-xl border border-gray-30 text-xs">
                Untagged
              </div>
            )
        }
      </div>
      <div className="text-sm text-left leading-snug my-2">
        {product?.description && product.description !== ''
          ? product.description
          : (<div className="italic text-gray-50">No description provided</div>)
        }
      </div>
    </Link>
  );
}

export default ArchitectureProductCard;